var map = {
	"./Bad Man.jpg": 8727,
	"./Cobalt Theme Main.png": 6731,
	"./House Music.png": 643,
	"./Liminal Song.png": 7199,
	"./Note To.png": 4765,
	"./Space Song.png": 5873,
	"./Step Bravely.png": 6605,
	"./Voice 8 From Cascando.png": 2852
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3482;